<template>
  <div class="loading">
    <img class="loading__img" :src="loadingImg" :alt="t.loading" />
  </div>
</template>

<script>
// utils
import translationStrings from '../../translations/translationStrings';

export default {
  name: 'loading',
  data() {
    return {
      t: translationStrings,
      loadingImg: `/${require('../../../images/leaf.svg')}`,
    };
  },
};
</script>
